function t(r) {
  return r ? r.replace(/\(TM\)/g, "<sup>™</sup>").replace(/\(r\)/g, "<sup>®</sup>") : "";
}
function u(r) {
  if (r == null) return "";
  const n = Math.floor(r / 1e3), o = Math.floor(n / 60);
  let e = Math.floor(n % 60);
  return e < 10 && (e = `0${e}`), `(${o}:${e})`;
}
export {
  t as formatText,
  u as formatTime
};
//# sourceMappingURL=formatters.mjs.map
